import { CALL_API } from '../../util/RBRestMiddleware'
import NgrxAuth from '../../auth/Auth'

export const EOB_LOADING = 'EOB_LOADING'
export const EOB_SUCCESS = 'EOB_SUCCESS'
export const EOB_FAILED = 'EOB_FAILED'

export const fetchEOBFile = (eobFileName, onSuccess, onError) => {
  return dispatch => {
    dispatch({
      [CALL_API]: {
        path: `/claims/${NgrxAuth.memberId}/getEOBFile/${eobFileName}`,
        prefix: 'EOB',
        'onSuccess': onSuccess,
        onError: onError
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/redux/actions/eobActions.js